import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Card from '@material-ui/core/Card';
import Button from '@material-ui/core/Button';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import ScheduleIcon from '@material-ui/icons/Schedule';
import MenuIcon from '@material-ui/icons/Menu';

import {  Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

import {
    ExpandMore as ExpandMoreIcon,
} from '@material-ui/icons';
import {
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Grid,
} from '@material-ui/core';

import ArticleList from '../article-list';

import OrderHelpers from './orderHelpers';

class AccordionOrder extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contextMenuOpen: false,
        };
    }

    get orderHelpers() {
        const {
            value,
            proceedOrder,
            declineOrder,
            showTotalPrice,
            openDeliveryDialog,
            printOrder,
            printing,
            isRoutePlanning,
            addOrderToRoute,
            removeOrderFromRoute,
            isIncludedInRoute,
            localSettings,
            selectOrderForDeliveryTimeInfo,
            classes,
        } = this.props;

        return new OrderHelpers({
            value,
            showTotalPrice,
            proceedOrder,
            declineOrder,
            printOrder,
            openDeliveryDialog,
            printing,
            isRoutePlanning,
            addOrderToRoute,
            removeOrderFromRoute,
            isIncludedInRoute,
            localSettings,
            selectOrderForDeliveryTimeInfo,
            classes,
            renderAsAccordion: true,
            handlePopOverClose: () => this.handlePopOverClose(),
        });
    }

    handlePopOverClose() {
        this.setState({ contextMenuOpen: false });
    }

    renderAccordionDetail(children, smSize = 6) {
        if (!children) {
            return null;
        }

        return (
            <Grid item xs={12} sm={smSize}>
                {children}
            </Grid>
        );
    }

    render() {
        const {
            classes,
            value,
            openDeliveryDialog,
            isRoutePlanning,
            localSettings,
            expanded,
        } = this.props;

        return (
            <div className={classes.orderContainer}>
                {this.orderHelpers.renderOrderLoadingIndicator()}
                <Accordion
                    expanded={expanded}
                    id={value.guid}
                >
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        style={this.orderHelpers.getOrderBackgroundStyle()}
                    >
                        <Grid container >
                            <Grid item xs={12} sm={3}>
                                <Typography>{value.isDelivery ? "Lieferung" : "Abholung"}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={3}>
                                <Typography>{value.pickupName}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={4}>
                                {this.orderHelpers.renderPreOrderTime(false)}
                            </Grid>
                            <Grid item xs={12} sm={2}>
                                <Typography>{value.pickupCode}</Typography>
                            </Grid>
                        </Grid>
                    </AccordionSummary>

                    <AccordionDetails className={classes.accordionDetails}>
                        <Grid container >
                            {this.renderAccordionDetail(this.orderHelpers.renderDispatchEvent(), 12)}
                            {this.renderAccordionDetail(this.orderHelpers.renderNotPaid(), 12)}
                            {this.renderAccordionDetail(this.orderHelpers.renderTakeaway(), 12)}
                            {this.renderAccordionDetail(this.orderHelpers.renderUserNote(), 12)}
                            {this.renderAccordionDetail(this.orderHelpers.renderNickname())}
                            {this.renderAccordionDetail(this.orderHelpers.renderPreOrderTime())}
                            {this.renderAccordionDetail(this.orderHelpers.renderPickupCode())}
                            {this.renderAccordionDetail(this.orderHelpers.renderOrderTime())}
                            {this.renderAccordionDetail(this.orderHelpers.renderSpotName())}
                            {this.renderAccordionDetail(this.orderHelpers.renderTelephone())}

                            <Grid xs={12} onClick={() => !isRoutePlanning && value.isDelivery && openDeliveryDialog(value)}>
                                {this.orderHelpers.renderDeliveryInformation(true)}
                            </Grid>

                            <Grid xs={12} className={classes.articleList}>
                                <ArticleList
                                    value={value.articles}
                                    tip={value.tip}
                                    showPrices={localSettings.showArticlePrice}
                                    showTip={localSettings.showTip}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {localSettings.showTotalPrice ? this.orderHelpers.renderTotalPrice() : null}
                            </Grid>

                            <Grid item xs={12}>
                                {this.orderHelpers.renderOrderActions()}
                            </Grid>
                        </Grid>
                    </AccordionDetails>
                </Accordion>
            </div>
        );
    }
}

const styles = theme => ({
    orderContainer: {
        marginBottom: '5px',
    },
    accordionDetails: {
        borderTop: '1px solid #eee',
    },
    actionButtonsContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        gap: '10px',
    },
    contextMenuContainer: {
        float: 'right',
        margin: '10px',
    },

    button: {
        fontSize: theme.order.buttons.fontSize,
        display: 'flex',
        'flex-grow': 1,
    },
    cardContent: {
        padding: 0,
    },
    header: {
        padding: 16,
    },
    headerLabel: {
        display: 'inline-block',
        width: 130,
    },
    headerLabelWide: {
        display: 'inline-block',
        width: 160,
    },
    inlineTypography: {
        display: 'inline-block',
    },
    inlineTypographyDotted: {
        display: 'inline-block',
        textDecoration: 'underline dotted',
        fontSize: 14,
        cursor: 'pointer',
    },
    articleList: {

    },
    totalPriceWrapper: {
        paddingLeft: '16px',
    },
    totalPrice: {
        fontWeight: 'bold',
    },
    userNote: {
        paddingLeft: '16px',
    },
    takeaway: {
        color: '#000',
        fontWeight: 'bold',
        // padding: '16px 0 0 16px',
    },
    cardAction: {
        display: 'flex',
    },
    note: {
        padding: '0 16px',
        color: theme.palette.error.dark,
    },
    deliveryInformation: {
        display: 'inline-block',
    },
});

AccordionOrder.defaultProps = {
    hideActions: false,
    showTotalPrice: false,
    isRoutePlanning: false,
    expanded: undefined,
};

AccordionOrder.propTypes = {
    classes: PropTypes.object.isRequired,
    value: PropTypes.object.isRequired,
    proceedOrder: PropTypes.func.isRequired,
    declineOrder: PropTypes.func.isRequired,
    printOrder: PropTypes.func.isRequired,
    openDeliveryDialog: PropTypes.func.isRequired,
    selectOrderForDeliveryTimeInfo: PropTypes.func.isRequired,
    hideActions: PropTypes.bool,
    isRoutePlanning: PropTypes.bool,
    showTotalPrice: PropTypes.bool,
    expanded: PropTypes.bool,
    localSettings: PropTypes.object.isRequired,
};

export default withStyles(styles)(AccordionOrder);
